// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingIndicator_container__1InpN","text":"LoadingIndicator_text__WXpol"};